export default [{
	name: '默认',
	value: [
		[{
			module_id: 1,
			module_type: 1
		}, {
			module_id: 2,
			module_type: 2
		}, {
			module_id: 3,
			module_type: 1
		}], [{
			module_id: 4,
			module_type: 3
		}, {
			module_id: 5,
			module_type: 3
		}]
	]
}, {
	name: '单模块',
	value: [
		[{
			module_id: 1,
			module_type: 3
		}]
	]
}, {
	name: '左右双模块',
	value: [
		[{
			module_id: 1,
			module_type: 1
		}, {
			module_id: 2,
			module_type: 3
		}]
	]
}, {
	name: '上下双模块',
	value: [
		[{
			module_id: 1,
			module_type: 1
		}], [{
			module_id: 2,
			module_type: 3
		}]
	]
}]